import React, { useState } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import FormPercentageCircle from "../FormPercentageCircle";
import StatsPanel from "../StatsPanel";
import BetButton from "../BetButton";
import styles from "./SelectionRow.module.scss";
import { SelectionMarketNameMap, DateTextMap } from "../../constants";
import { sendAnalyticsEvent } from "../../lib/postMessage";
import { handleTeamHighlight } from "../../lib";
import { CLOSE, OPEN, STATS_FILTER_TYPE } from "../../constants/analytics";

const SelectionRow = (selectionData) => {
  const {
    probability,
    marketType,
    selection,
    homeTeamName,
    awayTeamName,
    date,
    competitionName,
    stats,
    type,
    side,
  } = selectionData;
  const [toggleStatsPanel, setToggleStatsPanel] = useState(false);
  const handleStatsPanel = () => {
    setToggleStatsPanel(!toggleStatsPanel);
    sendAnalyticsEvent({
      event: "StatsPanel",
      type: STATS_FILTER_TYPE,
      action: toggleStatsPanel ? CLOSE : OPEN,
      market: SelectionMarketNameMap.get(marketType),
      selection: selection.name,
      match: `${homeTeamName} vs ${awayTeamName}`,
    });
  };

  return (
    <div
      className={styles.selectionRow}
      onClick={() => handleStatsPanel()}
      data-testid={`selectionRow-${selection.id}`}
    >
      <FormPercentageCircle probability={probability} />
      <div className={styles.selectionDetails}>
        <div className={styles.selectionName}>
          {SelectionMarketNameMap.get(marketType)}
        </div>
        <div className={styles.selectionOutcome}>{selection.name}</div>
        <div>
          {handleTeamHighlight(selectionData, homeTeamName, side, type)} v{" "}
          {handleTeamHighlight(selectionData, awayTeamName, side, type)} -{" "}
          {DateTextMap.get(dayjs(date).format("YYYY-MM-DD"))} at{" "}
          {dayjs(date).format("HH:mm")}
        </div>
        <div>{competitionName}</div>
      </div>
      <BetButton selectionData={selectionData} />
      <StatsPanel
        homeTeamName={homeTeamName}
        awayTeamName={awayTeamName}
        marketType={marketType}
        stats={stats}
        toggleStatsPanel={toggleStatsPanel}
        selectionName={selection.name}
        selectionType={selection.type}
        type={type}
      />
    </div>
  );
};

SelectionRow.propTypes = {
  probability: PropTypes.number,
  marketType: PropTypes.string,
  selection: PropTypes.shape({
    commonID: PropTypes.number,
    id: PropTypes.string,
    marketId: PropTypes.string,
    name: PropTypes.string,
    odds: PropTypes.string,
    oddsDecimal: PropTypes.number,
    type: PropTypes.string,
  }),
  homeTeamName: PropTypes.string,
  awayTeamName: PropTypes.string,
  date: PropTypes.string,
  competitionName: PropTypes.string,
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      numberOfMatches: PropTypes.number,
      numberOfWins: PropTypes.number,
      probability: PropTypes.number,
      type: PropTypes.string,
    })
  ),
  type: PropTypes.string,
  side: PropTypes.string,
};

export default SelectionRow;
